@if (asset) {
  <div class="row" [ngClass]="{ review: asset.is_review, 'device-selection': !is_offcanvas }">
    <div
      class="col col-12 col-sm-4 col-md-3 text-center text-sm-start bg-white item-image"
      [ngClass]="{ 'bg-white': !is_offcanvas }"
    >
      @if (getImageMetaData(asset.device?.image_url); as img) {
        <img
          [ngClass]="{
            'carrier-logo':
              (additional_asset && additional_asset_type === 'line') ||
              (!additional_asset &&
                is_offcanvas &&
                [multi_sim_types[1], multi_sim_types[2], multi_sim_types[6]].includes(
                  asset.multi_sim_type
                ))
          }"
          [alt]="img.alt"
          loading="lazy"
          [src]="img.src"
          (error)="imageLoadError($event, asset)"
        />
      }
    </div>
    @if (!is_offcanvas) {
      <div
        class="col col-12 col-sm-8 col-md-9 text-center text-sm-start"
        [ngClass]="{ 'device-selection__info': !is_offcanvas }"
      >
        @if (asset.line && asset.line?.carrier_image_url) {
          <img
            class="carrier-logo"
            [src]="asset.line.carrier_image_url"
            [alt]="asset.line.carrier_name"
          />
        }
        @if (asset.line && asset.line?.carrier_name) {
          <div class="mt-1">
            <small class="text-secondary lh-base d-block">
              {{ asset.line.carrier_name }}
            </small>
          </div>
        }
        @if (asset.line && asset.line.international_number) {
          <div class="mt-2">
            <span class="fw-normal">{{ asset.line.international_number }}</span>
            @if (asset.line.asset_primary_line && asset.multi_sim_type === multi_sim_types[0]) {
              <span class="material-icons text-info ms-1"> verified </span>
            }
          </div>
        }
        @if (asset?.device?.manufacturer && asset.device.model) {
          <div class="lh-1" [ngClass]="{ 'mt-2': !!asset.line }">
            <span class="fw-normal">{{ asset.device.manufacturer }} {{ asset.device.model }}</span>
            @if (
              asset.device.asset_primary_device &&
              [multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)
            ) {
              <span class="material-icons text-info ms-1"> verified </span>
            }
          </div>
        }
        <div class="mt-1">
          <small class="text-secondary lh-base d-block">
            @if (asset.device?.size) {
              <span> {{ asset.device.size }} - </span>
            }
            @if (asset.device?.color) {
              <span>
                {{ asset.device.color }}
              </span>
            }
          </small>
        </div>
        @if (asset.line?.id) {
          <div
            class="mt-2 me-1 d-flex gap-2 flex-wrap justify-content-center justify-content-sm-start status"
          >
            <!-- Status -->
            @if (asset.line.status) {
              <ts-status-badge
                [status]="asset.line.status"
                [status_display_name]="asset.line.status_display_name"
              />
            }
            <!-- Upgrade Eligibility -->
            <ts-eligibility-badge [line]="asset.line" />
          </div>
        }
      </div>
    }
    @if (!is_offcanvas) {
      <hr />
    }
    @if (!is_offcanvas && !additional_asset) {
      <div class="col device-selection__metadata">
        <span
          class="row row-cols-1 row-cols-sm-2"
          [ngClass]="[
            asset.is_review
              ? 'row-cols-md-1 row-cols-lg-2 row-cols-xl-1 px-3'
              : 'px-lg-5 device-selection__metadata--content'
          ]"
        >
          @for (display_info of asset_display_infos; track display_info) {
            <div class="col mb-3">
              <span class="d-block fw-normal">{{ display_info.label }}</span>
              <ng-container
                *ngTemplateOutlet="
                  isValueArray(display_info.value) ? list : span;
                  context: { value: display_info.value }
                "
              />
            </div>
          }
        </span>
      </div>
    } @else {
      <div class="col col-12 col-sm-8 col-md-9 ps-0">
        <div class="row">
          <div class="col d-flex align-items-center mb-3">
            <h5 class="d-inline-block mb-0">{{ additionalAssetTitle() }}</h5>
            @if (additionalAssetIsPrimary()) {
              <span class="material-icons d-inline-block ms-2 fs-inherit text-info">
                verified
              </span>
            }
            @if (showLineBadges(asset.multi_sim_type)) {
              <span class="d-inline-block ms-2">
                <ts-status-badge
                  [status]="additionalAssetAsLine().status"
                  [status_display_name]="additionalAssetAsLine().status_display_name"
                />
              </span>
            }
            @if (showLineBadges(asset.multi_sim_type)) {
              <span class="d-inline-block ms-2">
                <ts-eligibility-badge [line]="additionalAssetAsLine()" />
              </span>
            }
          </div>
        </div>
        <span class="row row-cols-1 row-cols-sm-2">
          @for (display_info of asset_display_infos; track display_info) {
            <div class="col mb-3">
              <span class="fw-normal" [ngClass]="{ 'd-block': !is_offcanvas }">
                {{ display_info.label }}{{ is_offcanvas ? ':' : '' }}
              </span>
              <ng-container
                *ngTemplateOutlet="
                  isValueArray(display_info.value) ? list : span;
                  context: { value: display_info.value }
                "
              />
            </div>
          }
        </span>
        <div
          ngbAccordion
          #accordion="ngbAccordion"
          [ngClass]="['col accordion-flush']"
          [closeOthers]="true"
        >
          @if (
            additional_asset_type === multi_sim_types[3] ||
            [multi_sim_types[1], multi_sim_types[5], multi_sim_types[6]].includes(
              asset.multi_sim_type
            )
          ) {
            <div
              ngbAccordionItem="Technical Specifications"
              [collapsed]="true"
              class="border rounded"
            >
              <h6 ngbAccordionHeader>
                <button ngbAccordionButton class="focus-visible focus-visible-inset rounded-top">
                  {{ 'tech_specs' | translate }}
                </button>
              </h6>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div class="row">
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'description' | translate }}:</span>
                        <span>{{
                          fieldExists(additionalAssetAsDevice()?.tech_specs?.description)
                        }}</span>
                      </div>
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'sim_compatibility' | translate }}:</span>
                        <span>
                          {{
                            fieldExists(additionalAssetAsDevice()?.tech_specs?.sim_compatibility)
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'battery' | translate }}:</span>
                        <span>{{
                          fieldExists(additionalAssetAsDevice()?.tech_specs?.battery)
                        }}</span>
                      </div>
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'weight' | translate }}:</span>
                        <span>{{
                          fieldExists(additionalAssetAsDevice()?.tech_specs?.weight)
                        }}</span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          }
          @if (
            additional_asset_type === multi_sim_types[4] ||
            [multi_sim_types[0], multi_sim_types[2]].includes(asset.multi_sim_type)
          ) {
            <div ngbAccordionItem="Service Details" [collapsed]="true" class="border rounded">
              <h6 ngbAccordionHeader>
                <button ngbAccordionButton class="focus-visible focus-visible-inset rounded-top">
                  {{ 'service_details' | translate }}
                </button>
              </h6>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div class="row">
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'carrier' | translate }}:</span>
                        <span>{{ fieldExists(additionalAssetAsLine()?.carrier_name) }}</span>
                      </div>
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'plan' | translate }}:</span>
                        <span>{{ fieldExists(additionalAssetAsLine()?.plan?.name) }}</span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col d-flex flex-column">
                        <span class="fw-normal">{{ 'add_on_features' | translate }}:</span>
                        @if (
                          (additionalAssetAsLine()?.plan &&
                            !additionalAssetAsLine()?.plan?.features) ||
                          !additionalAssetAsLine()?.plan
                        ) {
                          <span>
                            {{ 'n_a' | translate }}
                          </span>
                        } @else {
                          @for (feature of additionalAssetAsLine()?.plan?.features; track feature) {
                            <span>
                              {{ feature?.name }}
                            </span>
                          }
                        }
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<ng-template #span let-value="value">
  <span>{{ value }}</span>
</ng-template>

<ng-template #list let-values="value">
  <ul class="list-unstyled m-0">
    @for (value of values; track value) {
      <li>
        {{ value }}
      </li>
    }
  </ul>
</ng-template>
